export default e => ({
  name: e.name,
  url: e.value || e.url,
});



// WEBPACK FOOTER //
// ./src/transforms/CleanUploadFile.js